import Home from "../../../components/common/home";

export default function HomeView() {
  return <Home />;
}
